import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { commonPropTypes } from "./entities-selector";
import SelectComponent from "./SelectComponent";
import { useCurrentCustomerContext } from "../current-customer-context";
import { getContractsService } from "../../services/commonService";
import { LARGE_SELECT_LIMIT } from "./utils/select-constants";

const ContractSelect = ({
  multiple,
  name,
  label,
  id,
  handleChange,
  value,
  disabled = false,
  handleClick,
  contractsWithoutCustomer,
  customerId,
}) => {
  const { contracts, getContracts } = useCurrentCustomerContext();

  const [displayedContracts, setDisplayedContracts] = useState(contracts);

  const contractsCallback = data => {
    let contractsToSet = [...data];

    if (customerId) {
      const customerContracts = contracts.filter(item => item.customer_id === customerId);
      contractsToSet = contractsToSet.concat(customerContracts);
    }

    setDisplayedContracts(contractsToSet);
  };

  useEffect(() => {
    getContracts();
  }, []);

  useEffect(
    () => {
      if (contractsWithoutCustomer && !!contracts?.length) {
        getContractsService(contractsCallback, LARGE_SELECT_LIMIT, contractsWithoutCustomer);
      }
    },
    [contracts],
  );

  return (
    <SelectComponent
      disabled={disabled}
      name={name}
      multiple={multiple}
      label={label}
      id={id}
      value={value}
      handleChange={handleChange}
      elements={contractsWithoutCustomer ? displayedContracts : contracts}
      getValueFromElement={item => item._id}
      getLabelFromElement={item => item.description}
      itemKey="_id"
      itemValue="_id"
      itemLabel="description"
      handleClick={handleClick}
    />
  );
};

ContractSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default ContractSelect;
